import React from 'react';
import PropTypes from 'prop-types';

import { Flex, Span } from '@ubisend/pulse-components';
import { TemplatingTextInput } from '@ubisend/pulse-templating';

const ExportSectionContent = ({ content, onChange }) => {
  const handleSectionChange = sectionId => {
    onChange({ section_id: sectionId });
  };

  const handleEmailChange = email => {
    onChange({ email });
  };

  return (
    <Flex center fat="true" xSpace>
      <Flex col fat>
        <TemplatingTextInput
          aria-label="Section identifier"
          placeholder="Section identifier"
          value={content.section_id}
          onChange={handleSectionChange}
        />
      </Flex>
      <Span noWrap>and email to</Span>
      <Flex col fat>
        <TemplatingTextInput
          aria-label="Email"
          placeholder="Email"
          value={content.email}
          onChange={handleEmailChange}
        />
      </Flex>
    </Flex>
  );
};

ExportSectionContent.propTypes = {
  onChange: PropTypes.func.isRequired,
  content: PropTypes.shape({
    section_id: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired
  }).isRequired
};

export default ExportSectionContent;
